import { useMemo } from 'react'

import { EmploymentNotification } from '@builddocs/data-management'
import { Typography, Stack, Box, Link } from '@mui/material'

interface OwnProps {
  employment: EmploymentNotification
}

export type FireItemProps = OwnProps

export const FireItem = (props: FireItemProps) => {
  const { employment } = props

  const fontWeight = useMemo(
    () => (employment.viewed ? 'initial' : 'bold'),
    [employment.viewed],
  )

  return (
    <Stack direction="column">
      <Box>
        <Link
          sx={{ display: 'inline', fontWeight }}
          underline="hover"
          variant="body1"
        >
          {employment.senderName}
        </Link>
        <Typography sx={{ display: 'inline', fontWeight }} variant="body1">
          {' '}
          уволил вас с должности{' '}
        </Typography>
        <Link
          sx={{ display: 'inline', fontWeight }}
          underline="hover"
          variant="body1"
        >
          {employment.positionName}
        </Link>
      </Box>
    </Stack>
  )
}
